var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-container"},[_c('div',{staticClass:"header-container"},[_vm._t("header")],2),_c('div',{staticClass:"content-container"},[_vm._t("content")],2),_c('div',{staticClass:"action-container"},[_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }